import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IReportCategory } from "@/data/model/ReportCategory";
import { Format } from "@/data/util/Format";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { ReportCategoryForm } from "@/portal/forms/ReportCategoryForm";
import { TastierGlobal } from "@/portal/globalAccess";

export class ReportCategoryController extends BaseTabbedController<IReportCategory> {
    private categoryForm: ReportCategoryForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).reportCategoryDataSource);

        this.categoryForm = new ReportCategoryForm(this.formContentByTabName("categoryedit"));
        this.registerModelForm(this.categoryForm);
    }

    protected onModelLoaded(m?: IReportCategory) {
        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }

        this.categoryForm.setData(m);
    }
}
